import {
  EmptyState,
  useSlidesLibraryStoreShallow,
} from "@modules/slides-library/shared";
import { SearchSlidesSkeleton } from "@modules/slides-library/shared/components/skeleton/slides-library-content-skeleton";
import { useMemo } from "react";
import type { TDesignSlide } from "@/shared/types";
import { SingleSlidePreview } from "./single-slide-preview";

export const SearchResults = ({
  data,
  search,
}: {
  data: TDesignSlide[];
  search: string;
}) => {
  const isSearching = useSlidesLibraryStoreShallow((s) => s.isSearching);

  const titleMatched = useMemo(() => {
    if (!data) return [];
    const tokens = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (!tokens.length) return data;
    // Match across title + category (e.g. "horizontal timeline" → "Horizontal"
    // slides in the Timeline category). Mirrors SlideGridContent's matcher.
    return data.filter((slide) => {
      const haystack =
        `${slide.title} ${slide.categoryTitle ?? ""}`.toLowerCase();
      return tokens.every((t) => haystack.includes(t));
    });
  }, [data, search]);

  return (
    <div>
      <div className="tw-px-6 tw-py-4">
        <span className="tw-block tw-font-sans tw-text-sm tw-font-medium tw-text-blue">
          {isSearching ? (
            <span className="tw-block tw-h-5">
              <span className="tw-block tw-h-5 tw-w-36 tw-animate-pulse tw-rounded tw-bg-blue-100" />
            </span>
          ) : (
            `Search results for "${search}"`
          )}
        </span>
      </div>
      {isSearching ? (
        <SearchSlidesSkeleton count={6} />
      ) : titleMatched.length === 0 ? (
        <EmptyState title="No results found" />
      ) : (
        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-px-6 tw-pb-4">
          {titleMatched.map((slide) => (
            <SingleSlidePreview key={slide._id} slide={slide} showCategoryBadge />
          ))}
        </div>
      )}
    </div>
  );
};
